"use strict";

class PropertyAllDocumentsController {

    constructor($window, SSHttpService, SSUtilService, SSAlertService, SSConfigService, SSAppService, SSUserService, OTPService, $timeout) {
        const self = this;

        self.$window = $window;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;

        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;

        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
        self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SIDE_LETTER;
        self.PROPERTY_DOCUMENT_KIND_PDI_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
        self.PROPERTY_DOCUMENT_KIND_ANNEXES = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_A = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_B3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_C;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;
        self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION;
        self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM;
        self.PROPERTY_DOCUMENT_KIND_SPA_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SPA_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ICL_BANK_IN = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ICL_BANK_IN;
        self.PROPERTY_DOCUMENT_KIND_BANK_IN_LIST = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BANK_IN_LIST;
        self.PROPERTY_DOCUMENT_KIND_SALES_NOTE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SALES_NOTE;
        self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE;
        self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_B;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_C;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_D;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_E;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_G;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORMS_CHECK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORMS_CHECK;
        self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION;
        self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;

        self.data = SHOWSUITE.data;
        self.property_id = SHOWSUITE.data.property_id;
        self.download_all = false;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.documents = [];
        self.property_units = [];
        self.property = SHOWSUITE.data.property;
        self.getUnits();
        self.setDocumentKindValues();
        self.getPropertyDocuments();
    }

    getUnits() {
        const self = this;

        let url = 'properties/' + self.property.id + '/units';

        /** WEB:3043 Allow all units
        let unit_statuses = self.UNIT_STATUS_DRAFT + ',' +
                            self.UNIT_STATUS_LISTED + ',' +
                            self.UNIT_STATUS_RESERVED + ',' +
                            self.UNIT_STATUS_BOOKED + ',' +
                            self.UNIT_STATUS_SPECIAL_RESERVED; **/
        let params = {

            'offset': 0,
            'limit': 100000,
            // 'unit_status': unit_statuses, // WEB:3043 Allow all units
            'include': 'stacks'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.property_units && response.data.property_units.length > 0) {
                self.stacks = response.data.stacks;

                let units = angular.copy(response.data.property_units);
                units = self.SSUtilService.getSortedUnits(units, false, 'named_id');
                self.property_units = angular.copy(units);

                $.each(self.property_units, function(index, unit) {
                    self.formatUnitData(unit);
                });
                
                //Start downloading all documents
                // self.startDownloadAllDocuments();
            }
        });
    }

    setDocumentKindValues() {
        const self = this;

        self.document_kinds = [
            {
                'id': self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM,
                'kind': self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Declaration Form - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM,
                'kind': self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Cover Letter - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Side Letter - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_PDI_FORM,
                'kind': self.PROPERTY_DOCUMENT_KIND_PDI_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'PDI Form - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEXES,
                'kind': self.PROPERTY_DOCUMENT_KIND_ANNEXES,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annexes Document - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_A,
                'kind': self.PROPERTY_DOCUMENT_KIND_ANNEX_A,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex A - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_B3,
                'kind': self.PROPERTY_DOCUMENT_KIND_ANNEX_B3,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex B3 - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_C,
                'kind': self.PROPERTY_DOCUMENT_KIND_ANNEX_C,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex C - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT,
                'kind': self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Letter Of Agreement - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'kind': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Buyer Particulars - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'kind': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Purchaser Particulars Form - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_OTP,
                'kind': self.PROPERTY_DOCUMENT_KIND_OTP,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Option To Purchase (OTP) - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Buyer Congratulations Letter - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Selections Letter - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM,
                'kind': self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Elite Membership Form - Signable'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE,
                'kind': self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "3rd Party Payor Document - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT,
                'kind': self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "External Agent Represented - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A1,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form A1 - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A2,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form A2 - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_A3,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form A3 - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_B,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form B - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_C,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form C - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_D,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form D - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_E,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Form E - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "CDD Form F",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "CDD Form F Annexure 2",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORM_G,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "CDD Form G",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION,
                'kind': self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': "Letter of Authorisation - System Generated",
            },

            /** Following document kind not included for backend
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION,
                'kind': self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'EOI Application - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS,
                'kind': self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'EOI Ballot Tickets - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Key Handover Letter - System Generated'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SPA_LETTER,
                'kind': self.PROPERTY_DOCUMENT_KIND_SPA_LETTER,
                'type':self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name':"SPA Letter - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ICL_BANK_IN,
                'kind': self.PROPERTY_DOCUMENT_KIND_ICL_BANK_IN,
                'type':self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name':"Inward Check List (ICL) - System Generated",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BANK_IN_LIST,
                'kind': self.PROPERTY_DOCUMENT_KIND_BANK_IN_LIST,
                'type':self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name':"Bank In List (BIL) - System Generated",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SALES_NOTE,
                'kind': self.PROPERTY_DOCUMENT_KIND_SALES_NOTE,
                'type':self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name':"Sales Note - System Generated",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_CDD_FORMS_CHECK,
                'kind': self.PROPERTY_DOCUMENT_KIND_CDD_FORMS_CHECK,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "CDD Forms Check",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION,
                'kind': self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "Key Handover Collection Document - Signable",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT,
                'kind': self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "Buyer Declaration For Self Payment - Signable",
            }, **/
        ];
    }

    getPropertyDocuments() {
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/documents';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(!self.documents){ self.documents = []; } // Initialize documents array if undefined

            $.each(response.data.property_documents, function (index, document) {
                if(self.document_kinds.find(x => x.id === document.document_kind)){
                    self.documents.push(document);
                }
            });

            self.documents = _.sortBy(self.documents, 'order');
        });
    }

    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber1(unit, false);

        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';

        let stack = self.findStack(unit.stack_id);
        if (stack) {
            unit.block_no = stack.block_no;
            unit.stack_name = stack.name;
        }

        return unit;
    }

    findStack(stackId) {
        const self = this;

        let stack = null;

        $.each(self.stacks, function (i, _stack) {
            if (stackId == _stack.id) {
                stack = _stack;
                return false;
            }
        });

        return stack;
    }

    startDownloadAllDocuments() {
        const self = this;

        if (self.property_units.length > 0) {
            self.download_all = true;
            //Display warning message for disable popup blocker
            self.SSAlertService.success("Gentle Reminder.", "Please ensure your popup blocker is disabled in order to download all documents");
            self.downloadDocument(0);
        }
    }

    downloadAllUnitDocuments() {
        const self = this;

        let unit_id = self.selectedUnitId;
        let url = 'sec/developer/properties/' + self.property.id + '/documents/download?unit_ids=' + unit_id;
        let vUrl = self.SSHttpService.getApiURL(url);
        let params = {};
        params.device_uuid = self.SSUtilService.localStorageUUID();

        let headers = null;
        let request = {
            url: vUrl,
            method: "GET",
            withCredentials: true,
            headers,
            params
        };

        loading(true);

        return self.SSHttpService.$http(request)
            .then(function (response) {
                if (!response.data) {
                    self.SSAlertService.danger("Error!", "Unable to download document, please contact administrator!");
                    return;
                }

                let downloadUrl = self.SSHttpService.getApiURL(url) + '&device_uuid=' + self.SSUtilService.localStorageUUID();
                var a = document.createElement('A');
                a.href = downloadUrl;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                loading(false);
            });
    }

    downloadDocument(index) {
        const self = this;

        if (self.property_units.length <= index) {
            self.SSAlertService.success('Success!', 'Finished download all documents.');
            self.$timeout(function () {
                $(".table-bordered").click();
            });
            
            return;
        } else {
            let unit = self.property_units[index];

            let url = 'sec/developer/properties/' + self.property.id + '/documents/download?unit_ids=' + unit.id;

            let vUrl = self.SSHttpService.getApiURL(url);

            let params = {};
            params.device_uuid = self.SSUtilService.localStorageUUID();

            let headers = null;

            let request = {
                url: vUrl,
                method: "GET",
                withCredentials: true,
                headers,
                params
            };

            return self.SSHttpService.$http(request)
                .then(function (response) {
                    if (!response.data) {
                        unit.display_error = true;
                        self.downloadDocument(index+1);
                        return;
                    }

                    let downloadUrl = self.SSHttpService.getApiURL(url) + '&device_uuid=' + self.SSUtilService.localStorageUUID();
                    var a = document.createElement('A');
                    a.href = downloadUrl;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    unit.downloaded = true;

                    self.downloadDocument(index+1);
                });
        }
    }

    downloadSingleUnitDocument(doc) {
        const self = this;

        self.document_download_err = "";
        if (!self.selectedUnitId){
            console.warn('No unit selected');
            return;
        }

        let url = 'sec/developer/properties/' + self.property.id + '/documents/download?unit_ids='+ self.selectedUnitId +'&property_document_ids=' + doc.id;
        let vUrl = self.SSHttpService.getApiURL(url);
        let params = {};
        params.device_uuid = self.SSUtilService.localStorageUUID();

        let headers = null;
        let request = {
            url: vUrl,
            method: "GET",
            withCredentials: true,
            headers,
            params
        };

        loading(true);
        return self.SSHttpService.$http(request).then(function (response) {
            loading(false);
            if (!response.data) {
                self.SSAlertService.danger("Error!", "Unable to download document, please contact administrator!");
                self.document_download_err = "Unable to download document, please contact administrator!";
                return;
            }

            let downloadUrl = self.SSHttpService.getApiURL(url) + '&device_uuid=' + self.SSUtilService.localStorageUUID();
            var a = document.createElement('A');
            a.href = downloadUrl;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }).catch(function (e) {
            loading(false);
            console.error(e);
            self.document_download_err = "Unable to download document, please contact administrator!";
        })
    }

    openDownloadAllDocumentsModal( unit_id ) {
        const self = this;

        self.document_download_err = "";
        self.selectedUnitId = unit_id;
        self.filtered_documents = angular.copy(self.documents);
        self.filtered_documents = self.filtered_documents.filter(x => {
            let has_unit = x.units? x.units.toLowerCase() === 'all' || x.units.includes(self.getUnitNamedId(unit_id)) : true;
            return has_unit && x.file_uri; // Filter documents that are not enabled or do not have a file uri
        });

        $('#downloadDocumentModal').modal('show');
    }
    
    getUnitNamedId(unit_id) {
        const self = this;

        if (!self.property_units) return ""; // If not set return empty string
        return self.property_units.find(x => x.id === unit_id).named_id; // Return named id of unit
    }

    getDocumentKindName(document) {
        const self = this;

        let name = '--';
        if(!self.document_kinds || !document){ return name; }

        let document_kind = self.document_kinds.find(x => x.kind === document.document_kind && x.type === document.type);
        return document_kind ? document_kind.name : name;
    }
}

PropertyAllDocumentsController.$inject = ['$window', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSConfigService', 'SSAppService', 'SSUserService', 'OTPService', '$timeout'];
app.controller('PropertyAllDocumentsController', PropertyAllDocumentsController);

